import React, { useState } from 'react'
import ProgressBar from "react-bootstrap/ProgressBar";
import StrategyIcon from "assets/images/svg/StrategyIcon.svg";
import userImage from "assets/images/avatar.svg";
import classNames from "classnames";

import m1 from "assets/images/users/1.jpg";
import m2 from "assets/images/users/2.jpg";
import m3 from "assets/images/users/3.jpg";
import m4 from "assets/images/users/4.jpg";
import m5 from "assets/images/users/5.jpg";
import m6 from "assets/images/users/6.jpg";
import m7 from "assets/images/users/7.jpg";
import m8 from "assets/images/users/8.jpg";
import m9 from "assets/images/users/9.jpg";
import fm1 from "assets/images/users/01.jpg";
import fm2 from "assets/images/users/02.jpg";
import fm3 from "assets/images/users/03.jpg";
import fm5 from "assets/images/users/05.jpg";
import fm6 from "assets/images/users/06.jpg";
import fm7 from "assets/images/users/07.jpg";
import fm8 from "assets/images/users/08.jpg";
import fm9 from "assets/images/users/09.jpg";

export default function Strategy() {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const users = [m1, fm2, m3, fm1, m5, fm6, m2, m3, fm1, m5, fm5];

  const datas = [
    {
      title:
        "Optimize the company's supply chain for improved efficiency, cost-effectiveness.",
      date: "Q1 FY24",
      issues: 3,
      isOnTracking: true,
      progress: 70,
    },
    {
      title: "Develop and implement a comprehensive risk management strategy",
      date: "Q1 FY24",
      issues: 0,
      isOnTracking: true,
      progress: 70,
    },
    {
      title: "Ensure compliance with regulatory requirements",
      date: "Q1 FY24",
      issues: 0,
      isOnTracking: true,
      progress: 90,
    },
    {
      title: "Manage and monitor the company's exposure to financial risks",
      date: "Q1 FY24",
      issues: 0,
      isOnTracking: true,
      progress: 60,
    },
    {
      title: "Monitor and manage the company's exposure to operational risks",
      date: "Q1 FY24",
      issues: 2,
      isOnTracking: false,
      progress: 50,
    },
    {
      title: "Increase revenue and profitability",
      date: "Q1 FY24",
      issues: 0,
      isOnTracking: true,
      progress: 40,
    },
    {
      title: "Expand market share",
      date: "Q1 FY24",
      issues: 2,
      isOnTracking: false,
      progress: 40,
    },
    {
      title: "Improve operational efficiency",
      date: "Q1 FY24",
      issues: 0,
      isOnTracking: true,
      progress: 40,
    },
    {
      title: "Enhance customer satisfaction",
      date: "Q1 FY24",
      issues: 2,
      isOnTracking: true,
      progress: 40,
    },
    {
      title: "Foster innovation",
      date: "Q1 FY24",
      issues: 0,
      isOnTracking: true,
      progress: 100,
    },
  ];

  const searchDropdownData = [
    {
      name: "Risks",
      value: 307,
    },
    {
      name: "Controls",
      value: 127,
    },
    {
      name: "Processes",
      value: 468,
    },
    {
      name: "Regulations",
      value: 96,
    },
    {
      name: "Vendors",
      value: 163,
    },

  ]

  const fromGroupClass = classNames({
    "d-flex position-relative ease-in-2ms": true,
    "border-bottom-gray-600 pb-3 mb-3": isDropdownOpen,
  });

  const timeLineClass = classNames({
    "time-line slide-in": true,
    "slide-down": isDropdownOpen,
  });


  return (
    <div className="pa-3">
      <form className="search-form">
        <div className={fromGroupClass}>
          <h3
            className="fw-300 cp d-inline-flex align-items-center"
            onClick={() => setDropdownOpen(!isDropdownOpen)}
          >
            Strategy
            <i className="icon-chevron-down ml-1"></i>
          </h3>
          <input title="Search" type="text" />
          <i className="icon-search placeholder-icon"></i>
        </div>

        <ul className={timeLineClass}>
          {searchDropdownData.map((data, i) => (
            <li className="" key={i}>
              <h6 className="text-gray-50 fw-400">{data.name}</h6>
              <small>
                <span className="dot bg-indigo-600 mr-1"></span> {data.value}
              </small>
            </li>
          ))}
        </ul>
      </form>

      {/* Timeline */}

      <ul className="time-line">
        {datas.map((data, i) => (
          <li className="d-flex justify-content-between" key={i}>
            <div className="col-6 d-inline-flex align-items-center">
              <span
                className="circle text-white bg-gray-800"
                style={{
                  width: "2.5rem",
                  height: "2.5rem",
                  overflow: "visible",
                }}
              >
                <img
                  src={StrategyIcon}
                  style={{ width: "1.25rem" }}
                  alt="Strategy"
                />
              </span>

              <div className="ml-3">
                <h6 className="text-gray-50 fw-400">{data.title}</h6>
                <span className="text-gray-400">
                  <i className="icon-calendar mr-2"></i>
                  {data.date}
                  {data.issues > 0 && (
                    <>
                      <span className="mh-2">|</span>
                      <span className="text-danger">
                        {data.issues} issues identified
                      </span>
                    </>
                  )}
                </span>
              </div>
            </div>

            <div className="col-4  justify-content-end">
              <div className="d-flex">
                <img
                  className="circle mt-2 bg-gray-500 mr-3"
                  style={{ width: "1.75rem", height: "1.75rem" }}
                  src={users[i]}
                  alt="User"
                />
                <div className="fw">
                  <div className="d-flex align-items-center">
                    <ProgressBar
                      variant={data.isOnTracking ? "" : "danger"}
                      now={data.progress}
                    />
                    <span
                      className={
                        data.isOnTracking ? "ml-3" : "ml-3 text-danger"
                      }
                    >
                      {data.progress}%
                    </span>
                  </div>

                  <small className="text-gray-500 fw-300 mt-2">
                    {data.isOnTracking ? "On track" : "Delayed"}
                  </small>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
